import { type ClassValue, clsx } from 'clsx';
import { RgbaColor } from 'react-colorful';
import { twMerge } from 'tailwind-merge';
import { Langs } from './schemas/enums';
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
export function linkFromEmblem(
  gameType: 'game' | 'scenario',
  emblem: string
): string {
  const url = `${process.env.NEXT_PUBLIC_BASE_URL}/${gameType}/${emblem}`;
  return url;
}

// export function formatBytes(
//   bytes: number,
//   opts: {
//     decimals?: number;
//     sizeType?: 'accurate' | 'normal';
//   } = {}
// ) {
//   const { decimals = 0, sizeType = 'normal' } = opts;

//   const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
//   const accurateSizes = ['Bytes', 'KiB', 'MiB', 'GiB', 'TiB'];
//   if (bytes === 0) return '0 Byte';
//   const i = Math.floor(Math.log(bytes) / Math.log(1024));
//   return `${(bytes / Math.pow(1024, i)).toFixed(decimals)} ${sizeType === 'accurate'
//     ? (accurateSizes[i] ?? 'Bytest')
//     : (sizes[i] ?? 'Bytes')
//     }`;
// }

export function convertSelectedLangs(selectedLangs: string) {
  const langs = selectedLangs.split(',') as Langs[];
  return langs.filter((str: string) => str !== '');
}

export function parseTimeString(timeString: string): number {
  const [hours, minutes] = timeString.split(':').map(Number);
  return hours * 60 + minutes;
}

export function rgbaToCSS(color: RgbaColor): string {
  try {
    return `rgba(${color.r},${color.g},${color.b},${color.a})`;
  } catch (e) {
    return `rgba(0,0,0,0)`;
  }
}
